/* eslint-disable */
import {
	Check,
	WarningRounded,
	FormatItalic,
	Edit,
	DeviceThermostat,
	Close,
	TripOrigin,
	CenterFocusStrong,
	GridOn,
} from '@mui/icons-material';
// eslint-disable-next-line object-curly-newline
import { Badge, Button, Divider, IconButton, ListItemIcon, ListItemText, MenuItem, MenuList, Popover, Slider, Tooltip } from '@mui/material';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useMemo, useState } from 'react';
import { formActions, modalActions } from '../../../../Actions';
import { modalTypes, urls } from '../../../../Constants';
import { classes } from '../../../../Helpers';
import invalidMeal from '../../../../Images/invalidMeal.svg';
import CMSRecipeItemsList from '../VideoFeed/CMSRecipeItemsList/CMSRecipeItemsList';
import compIden from '../../../../Images/compIden.png';
import crate from '../../../../Images/crate.png';
import aIcon from '../../../../Images/aIcon.png';
import styles from './FeedHUD.module.scss';
import GenericItemList from '../GenericItemList/GenericItemList';
import duplicateIcon from '../../../../Images/duplicateIcon.png';
import { useAuth } from '@/Components/Auth/Login/auth';
import useHeatGrid from '../TempHUD/useHeatGrid';
import DeleteIcon from '@mui/icons-material/Delete';

const URL_TYPE = {
	QMS: 'QMS_ANNOTATION',
	IMS: 'IMS_ANNOTATION',
};

// Heat view modes, in menu order. `on`/`all` are the useHeatGrid settings each mode stands for.
const HEAT_VIEWS = [
	{ key: 'circles', label: 'Circles', Icon: TripOrigin, on: false, all: false },
	{ key: 'object', label: 'Object', Icon: CenterFocusStrong, on: true, all: false },
	{ key: 'all', label: 'Whole grid', Icon: GridOn, on: true, all: true },
];

const FeedHUD = (props) => {
	const {
		result,
		// identifiedProducts,
		// orderId,
		// itemId,
		currentIndex,
		showAnnotation,
		showRetag,
		showValidate,
		showFirstTimeValidate,
		toggleRetagModal,
		scanId,
		identification,
		features,
		identity,
		validateSKU,
		type,
		setTempVisibility,
		tempVisibility,
		grid,
		sensorValues,
		isDuplicate,
		hideAnnotation,
		ingredients,
		isCms,
		weightByComponents,
		currentRecipe,
		setCurrentRecipe,
		message,
		productsList,
		getPastQCDetails,
		isWastage,
		wastageReason,
		// fetchProducts,
		container,
		brandCheck,
		onDuplicacy = () => { },
		duplicateActionBy,
		unit,
		recipe,
		showRawImage,
		rawImage,
		handleShowImage = () => { },
		combineCMSBatches,
	} = props;

	const { userConfig = {} } = useAuth();
	const [heatGrid, setHeatGrid] = useHeatGrid();
	const [viewAnchor, setViewAnchor] = useState(null);
	const heatView = HEAT_VIEWS.find((v) => v.on === heatGrid.on && v.all === (heatGrid.on && heatGrid.all)) ?? HEAT_VIEWS[0];
	const viewTitle = `Heat view: ${heatView.label} (click to change)`;
	const pickHeatView = ({ on, all }) => {
		setTempVisibility(true);
		setHeatGrid('on', on);
		setHeatGrid('all', all);
	};
	const { level } = userConfig?.userDetails || {};
	const { clientType } = JSON.parse(localStorage.getItem('appConfig'));

	const isIdentified = useMemo(() => {
		return (
			identification?.x != null &&
			identification?.y != null &&
			identification?.width != null &&
			identification?.height != null
		);
	}, [identification]);

	const containerChip = useMemo(() => {
		const { source, aiConf, aiContainer } = container ?? {};
		if (source === 'AI') {
			if (aiContainer?.weight === 0) return 'AI · no container';
			return aiConf != null ? `AI ${Number(aiConf).toFixed(2)}` : 'AI';
		}
		if (source === 'OVERRIDE') {
			return aiContainer?.name ? `Override (AI: ${aiContainer.name})` : 'Override';
		}
		return { OPERATOR: 'Operator' }[source] ?? null;
	}, [container]);

	const brandText = useMemo(() => {
		if (!brandCheck || brandCheck.match == null || !brandCheck.detectedBrand) return null;
		const conf = brandCheck.confidence != null ? ` (${Number(brandCheck.confidence).toFixed(2)})` : '';
		return brandCheck.match
			? `Brand: ${brandCheck.detectedBrand} ✓${conf}`
			: `Brand: ${brandCheck.detectedBrand} ✗, expected ${brandCheck.expectedBrand ?? '-'}${conf}`;
	}, [brandCheck]);

	// useEffect(() => {
	// if (productsList?.length < 1) {
	// fetchProducts({
	// entity: 'ALL_PRODUCTS',
	// req: {
	// params: {
	// id: '',
	// },
	// },
	// method: 'LIST',
	// });
	// }
	// }, [productsList]);
	return (
		<div className={classes(styles.root, styles[result])}>
			{currentRecipe?.unit === 'count' && !currentRecipe?.calibrationWeight && isCms && combineCMSBatches && (
				<div className='absolute z-[1000] left-[13px] top-0 bg-white text-red-500 p-[4px_8px] rounded-[5px] bg-[#feed] text-[16px]'>
					Calibration Order
				</div>
			)}
			{isCms ? (
				<div className={styles['ingredients-images']}>
					<CMSRecipeItemsList
						currentRecipe={currentRecipe}
						onClick={setCurrentRecipe}
						ingredients={ingredients}
						unit={unit}
						getPastQCDetails={getPastQCDetails}
						isCms={isCms}
						recipe={recipe}
						combineCMSBatches={combineCMSBatches}
					/>
				</div>
			) : (
				result && (
					<div className={classes(styles.qcDone, styles[result])}>
						<p>{message}</p>
					</div>
				)
			)}
			{weightByComponents && (
				<div className={styles.itemsBar}>
					<GenericItemList
						productsList={productsList}
						idKeyValueData={weightByComponents}
					/>
				</div>
			)}

			{isWastage &&
				(Array.isArray(wastageReason) && wastageReason?.length > 0 ? (
					<div className={styles?.wastageReasons}>
						<div className={styles?.text}> Wastage reasons: </div>
						{wastageReason?.map((reason) => {
							return (
								<Tooltip title={reason} arrow followCursor>
									<div className={styles.reason}>
										<div />
										{reason &&
											reason?.substring(0, 15) + '...'}
									</div>
								</Tooltip>
							);
						})}
					</div>
				) : (
					<div className={styles?.wastageReasons}>
						<div className={styles?.text}> Wastage reason: </div>
						<Tooltip title={wastageReason} arrow followCursor>
							<div className={styles.reason}>
								<div />
								{wastageReason &&
									wastageReason?.substring(0, 15) + '...'}
							</div>
						</Tooltip>
					</div>
				))}
			{isDuplicate && (
				<div className='absolute w-full flex justify-end h-auto'>
					<div className='bg-slate-50 p-2 rounded-md min-w-[120px] min-h-[100px] max-w-[200px] flex flex-col justify-center items-center relative top-20 right-12'>
						<img className='w-[60px] h-[60px] flex-shrink-0 animate-pulse animate-ping' style={{ animation: 'scaleUpDown 2s ease-in-out infinite' }} src={invalidMeal} alt='invalid' />
						<style jsx>{`
						@keyframes scaleUpDown {
							0%, 100% { transform: scale(1); }
							50% { transform: scale(1.1); }
						}
					`}</style>
						<p className='text-center text-xs sm:text-sm text-red-600 font-bold leading-tight break-words'>Potential duplicate</p>
					</div>
				</div>
			)}
			{duplicateActionBy && (
				<div className={styles.marked_by}>
					<p>Marked {isDuplicate ? 'Duplicate' : 'Non-Duplicate'} by: {duplicateActionBy}</p>
				</div>
			)}
			{/* <div className={classes(styles.left, styles.stat)}>
				<span>
					{`${orderId != null ? `${orderId}/` : ''}
				${itemId ?? ''}`}
				</span>
				<span>{result}</span>
			</div> */}
			{result !== 'SKIPPED' && !hideAnnotation && (
				<>
					{level !== 1 && (isIdentified || isWastage) && showAnnotation && (
						<div
							className={classes(
								styles.features,
								styles['action-wrapper']
							)}
						>
							<Link
								className={styles.link}
								to={`${urls.EXTENSION}${urls[URL_TYPE[type]]
									}/${currentIndex}?id=${scanId}&ctx=FEATURES&type=QUALITY${isCms
										? `&CMS=true&recipeId=${currentRecipe?.qcId}`
										: ''
									}`}
							>
								<Badge
									className={styles.action}
									badgeContent={
										features?.length ?? features ?? 0
									}
									color='error'
								>
									<Tooltip title='Features' arrow>
										<Button
											className={styles.action}
											variant='contained'
											color='primary'
										>
											<WarningRounded fontSize='large' />
										</Button>
									</Tooltip>
								</Badge>
							</Link>
						</div>
					)}
					{(clientType == 'SCHOOL' || showRetag) && level !== 1 && (
						<div
							className={classes(
								styles.retag,
								styles['action-wrapper']
							)}
						>
							<Link
								className={styles.link}
								to={
									clientType === 'SCHOOL'
										? `${urls.EXTENSION}${urls[URL_TYPE[type]]
										}/${currentIndex}?id=${scanId}&ctx=FEATURES&type=IDENTITY,COMPONENT${isCms
											? `&CMS=true&recipeId=${currentRecipe?.qcId}`
											: ''
										}`
										: `${urls.EXTENSION}${urls[URL_TYPE[type]]
										}/${currentIndex}?id=${scanId}&ctx=IDENTIFICATION${isCms
											? `&CMS=true&recipeId=${currentRecipe?.qcId}`
											: ''
										}`
								}
							>
								<Tooltip title='Identification' arrow>
									<Button
										className={styles.action}
										variant='contained'
										color='primary'
									>
										<FormatItalic />
									</Button>
								</Tooltip>
							</Link>
							{isIdentified && (
								<span className={styles.status}>
									<Check />
									{identification?.ai != null &&
										(identification?.ai ? (
											<>
												<span
													className={styles.statusAi}
												>
													Ai
												</span>
											</>
										) : (
											<>
												<span
													className={styles.statusMn}
												>
													Mn
												</span>
											</>
										))}
								</span>
							)}
						</div>
					)}
					{(isIdentified || isWastage) && !showFirstTimeValidate && level !== 1 && (
						<div
							className={classes(
								styles.retag,
								styles['action-wrapper']
							)}
						>
							<Link
								className={styles.link}
								to={`${urls.EXTENSION}${urls[URL_TYPE[type]]
									}/${currentIndex}?id=${scanId}&ctx=FEATURES&type=IDENTITY,COMPONENT${isCms
										? `&CMS=true&recipeId=${currentRecipe?.qcId}`
										: ''
									}`}
							>
								<Badge
									className={styles.action}
									badgeContent={identity ?? 0}
									color='success'
								>
									<Tooltip
										title='Component Identification'
										arrow
									>
										<Button
											className={styles.action}
											variant='contained'
											color='primary'
										>
											<img
												width={24}
												src={compIden}
												alt='comp'
											/>
										</Button>
									</Tooltip>
								</Badge>
							</Link>
						</div>
					)}
					{(isIdentified || isWastage) && !showFirstTimeValidate && level !== 1 && (
						<div
							className={classes(
								styles.retag,
								styles['action-wrapper']
							)}
						>
							<Link
								className={styles.link}
								to={`${urls.EXTENSION}${urls[URL_TYPE[type]]
									}/${currentIndex}?id=${scanId}&ctx=CONTAINER&type=CRATE${isCms
										? `&CMS=true&recipeId=${currentRecipe?.qcId}`
										: ''
									}`}
							>
								<Tooltip title='Crate Identification' arrow>
									<Button
										className={styles.action}
										variant='contained'
										color='primary'
									>
										<img
											width={24}
											src={crate}
											alt='crate'
										/>
									</Button>
								</Tooltip>
							</Link>
						</div>
					)}
					{level !== 1 && !features > 0 && showValidate && (
						<div
							className={classes(
								styles.validate,
								styles['action-wrapper']
							)}
						>
							<Tooltip title='Change SKU' arrow>
								<Button
									className={styles.action}
									variant='contained'
									color='primary'
									onClick={() => {
										toggleRetagModal(true);
									}}
								>
									<Edit />
								</Button>
							</Tooltip>
						</div>
					)}
					{((sensorValues && sensorValues?.length > 0) || grid) && (
						<div
							className={classes(
								styles.validate,
								styles['action-wrapper']
							)}
						>
							<Tooltip
								title={
									tempVisibility
										? 'Hide Temperature'
										: 'Show Temperature'
								}
								arrow
							>
								<Button
									className={styles.action}
									variant='contained'
									color={
										tempVisibility ? 'success' : 'primary'
									}
									onClick={() => {
										setTempVisibility((prevState) => {
											return !prevState;
										});
									}}
								>
									<DeviceThermostat />
								</Button>
							</Tooltip>
							{grid && (
								<>
									<Tooltip title={viewTitle} arrow>
										<Button
											variant='contained'
											color={tempVisibility ? 'success' : 'primary'}
											aria-label={viewTitle}
											aria-haspopup='menu'
											aria-expanded={Boolean(viewAnchor)}
											sx={{ minWidth: 0, width: 34, height: 34, p: 0, borderRadius: '50%' }}
											onClick={(e) => setViewAnchor(viewAnchor ? null : e.currentTarget)}
										>
											<heatView.Icon sx={{ fontSize: 20 }} />
										</Button>
									</Tooltip>
									<Popover
										open={Boolean(viewAnchor)}
										anchorEl={viewAnchor}
										onClose={() => setViewAnchor(null)}
										anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
										transformOrigin={{ vertical: 'top', horizontal: 'left' }}
										slotProps={{ paper: { sx: { ml: 1, borderRadius: '8px', boxShadow: '0 4px 14px rgba(0,0,0,.3)', minWidth: 200 } } }}
									>
										<MenuList autoFocusItem sx={{ py: 0.5 }}>
											{HEAT_VIEWS.map((v) => (
												<MenuItem
													key={v.key}
													selected={v.key === heatView.key}
													onClick={() => pickHeatView(v)}
													sx={{ minHeight: 38, '&.Mui-selected': { bgcolor: 'rgba(46,125,50,.12)' } }}
												>
													<ListItemIcon><v.Icon sx={{ fontSize: 20 }} /></ListItemIcon>
													<ListItemText>{v.label}</ListItemText>
													{v.key === heatView.key && <Check fontSize='small' color='success' />}
												</MenuItem>
											))}
										</MenuList>
										{heatGrid.on && (
											<>
												<Divider />
												<div style={{ padding: '8px 16px 10px' }}>
													<div style={{ fontSize: 13 }}>Transparency {heatGrid.opacity}%</div>
													<Slider size='small' aria-label='Transparency' value={heatGrid.opacity} onChange={(e, v) => setHeatGrid('opacity', v)} />
												</div>
											</>
										)}
									</Popover>
								</>
							)}
						</div>
					)}
					{level !== 1 && (
						<div className={styles.mark_unmark_wrapper}>
							<Tooltip
								title={
									isDuplicate
										? 'Mark Non-Duplicate'
										: 'Mark Duplicate'
								}
							>
								<button
									onClick={() => {
										onDuplicacy(!isDuplicate);
									}}
									type='button'
									className={styles.unmark_btn}
								>
									{/* <DoDisturbAlt /> */}
									<img
										className={styles.icon}
										src={duplicateIcon}
										alt=''
									/>
								</button>
							</Tooltip>
						</div>
					)}
					{showRawImage && (
						<div className={styles.mark_unmark_wrapper}>
							<Tooltip
								title='Raw Image'
							>
								<button
									onClick={handleShowImage}
									type='button'
									className={styles.unmark_btn}
								>
									{/* <DoDisturbAlt /> */}
									<img
										className={styles.icon}
										src={aIcon}
										alt=''
									/>
								</button>
							</Tooltip>
						</div>

					)}
					{clientType !== 'SCHOOL' && showFirstTimeValidate && level !== 1 && (
						<div className={styles['first-time-validate']}>
							<span className={styles['validate-label']}>
								Is AI Identification Correct?
								<br />
							</span>
							<div className={styles['validate-actions']}>
								<Tooltip title='NO'>
									<IconButton
										className={classes(
											styles['validate-action'],
											styles['not-valid']
										)}
										onClick={() => {
											toggleRetagModal(true, {
												defaultSelect: -1,
											});
										}}
									>
										<Close />
									</IconButton>
								</Tooltip>
								<Tooltip title='YES'>
									<IconButton
										className={classes(
											styles['validate-action'],
											styles.valid
										)}
										onClick={() => {
											validateSKU();
										}}
									>
										<Check />
									</IconButton>
								</Tooltip>
							</div>
						</div>
					)}
					<div className={styles.footer}>
						{(identification?.label || brandText) && (
							<div className={styles.identification}>
								{identification?.label && <span>{identification?.label}</span>}
								{brandText && (
									<p style={{ color: brandCheck.match ? '#00aa2b' : '#ff4d4f' }}>
										{brandText}
									</p>
								)}
							</div>
						)}
						{(container?.id ||
							container?.containerId ||
							container?.aiContainer?.id) && (
							<div className={styles.container}>
								{container?.image && (
									<img
										className={styles.image}
										src={container?.image}
										alt={container?.name}
									/>
								)}
								<div className={styles['name-weight']}>
									<p>
										{container?.name ??
											(container?.containerId
												? `Container #${container.containerId}`
												: 'No container')}
									</p>
									<p>
										{container?.masterWeight != null &&
											`Tare ${container?.masterWeight} ${container?.unit} · `}
										Applied {container?.appliedWeight ?? 0}{' '}
										{container?.unit}
									</p>
									{containerChip && <p>{containerChip}</p>}
								</div>
							</div>
						)}
					</div>
				</>
			)}
		</div>
	);
};

FeedHUD.defaultProps = {
	result: '',
	orderId: null,
	itemId: null,
	currentIndex: 0,
	showAnnotation: false,
	showRetag: false,
	showValidate: false,
	showFirstTimeValidate: false,
	type: 'QMS',
	validateSKU: () => { },
};

const mapStateToProps = (state) => {
	const productsList = state.form.ALL_PRODUCTS.data.LIST;
	return {
		productsList,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchProducts: formActions.gateway,
		toggleRetagModal: (show, data = {}) => {
			dispatch(modalActions.toggleModal(modalTypes.RETAG, show, data));
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedHUD);
